var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZeroSpam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 71,
    viewBox: "0 0 200 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1162",
    "data-name": "Rectangle 1162",
    width: 78,
    height: 13.6,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968",
    transform: "translate(-570 -539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932",
    transform: "translate(569.972 538.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1142",
    "data-name": "Rectangle 1142",
    transform: "translate(0.028 0.298)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 71,
    rx: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 199,
    height: 70,
    rx: 12.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_923",
    "data-name": "Group 923",
    transform: "translate(27.505 23.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    transform: "translate(-0.476 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: 13,
    rx: 13.5,
    ry: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: 13,
    rx: 12.5,
    ry: 12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M4663.117,542.142l12.838,20.838",
    transform: "translate(-4656.429 -539.681)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961",
    transform: "translate(65.028 29.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M0,10.5l4.6-8H.6V.1H8.9V.4l-4.5,8H8.7v2.4H0v-.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M9.4,7h0a4.042,4.042,0,0,1,4.2-4.2c2.3,0,4,1.2,4,4v.7H12.1a1.522,1.522,0,0,0,1.6,1.6c.9,0,1.3-.4,1.4-.9h2.5C17.4,10,16,11,13.6,11S9.3,9.6,9.3,7Zm5.7-1a1.342,1.342,0,0,0-1.4-1.5q-1.35,0-1.5,1.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M18.8,3h2.7V4.6A2.457,2.457,0,0,1,24,2.9V5.4c-1.6,0-2.5.5-2.5,1.7v3.7H18.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M24.7,7h0A4.068,4.068,0,0,1,29,2.8c2.4,0,4.3,1.5,4.3,4A4.013,4.013,0,0,1,29,11c-2.4,0-4.3-1.5-4.3-4m5.9-.1h0c0-1.4-.5-2.2-1.5-2.2s-1.6.7-1.6,2c0,1.5.5,2.2,1.6,2.2s1.5-.8,1.5-2.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M37,7.4h2.9c0,.8.4,1.4,1.7,1.4S43,8.4,43,7.7s-.4-.8-1.7-1c-3-.4-4-1.3-4-3.4S38.9,0,41.5,0s4,1.1,4.2,3.3H42.9a1.215,1.215,0,0,0-1.4-1.2c-.9,0-1.2.4-1.2.9s.3.9,1.7,1c2.7.3,4.1,1,4.1,3.3s-1.6,3.6-4.3,3.6-4.5-1.3-4.6-3.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M47.2,3h2.7V4.2a2.775,2.775,0,0,1,2.4-1.4c1.8,0,3.3,1.4,3.3,4.1,0,2.8-1.5,4.2-3.3,4.2s-2-.6-2.4-1.3v3.8H47.2V3Zm5.7,3.9h0c0-1.5-.6-2.2-1.5-2.2s-1.6.7-1.6,2c0,1.5.6,2.1,1.6,2.1s1.5-.7,1.5-2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M56.3,8.6c0-1.8,1.6-2.6,4.2-2.6h.8V5.8c0-.8-.2-1.2-1-1.2a.959.959,0,0,0-1.1.9H56.7c.1-1.9,1.6-2.8,3.8-2.8s3.5.9,3.5,3v5.1H61.4V9.9A2.571,2.571,0,0,1,59.1,11a2.488,2.488,0,0,1-2.7-2.4Zm5-.5V7.6h-.7c-1.1,0-1.6.2-1.6.9s.3.7.9.7a1.221,1.221,0,0,0,1.3-1.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M65.5,3h2.7V4.2a2.6,2.6,0,0,1,2.5-1.4,1.89,1.89,0,0,1,2.1,1.3,3.172,3.172,0,0,1,2.6-1.3c1.5,0,2.6,1,2.6,2.9v5.1H75.3V6.1c0-.8-.4-1.2-1-1.2a1.241,1.241,0,0,0-1.2,1.3v4.5H70.4V6c0-.8-.4-1.2-1-1.2a1.241,1.241,0,0,0-1.2,1.3v4.5H65.5V3Z",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroSpam);
export default __webpack_public_path__ + "static/media/zeroSpam.326559a59d3263aad08833cf033570f9.svg";
export { ForwardRef as ReactComponent };